// src/pages/ContactsPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";



function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease;
            }
            .grid-rows-pro table tbody tr:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro table tbody tr:hover {
                background: #eff6ff !important;
            }
            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #111827;
                vertical-align: top;
            }
            .grid-rows-pro table tbody td .grid-row-main {
                font-weight: 700;
                color: #111827;
            }
            .grid-rows-pro table tbody td .grid-row-sub {
                color: #6b7280;
                font-size: 12px;
            }
            .grid-rows-pro .list-hover-item {
                transition: background 0.18s ease;
            }
            .grid-rows-pro .list-hover-item:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro .list-hover-item:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro .list-hover-item:hover {
                background: #eff6ff !important;
            }

            .contacts-pro .company-badge{
                display:inline-flex;
                align-items:center;
                max-width:260px;
                border-radius:999px;
                border:1px solid #0ea5e9;
                background:#0b2740;
                color:#d9f4ff;
                padding:4px 9px;
                font-size:10px;
                font-weight:700;
                line-height:1.1;
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
            }
            .contacts-pro .company-badge-empty{
                display:inline-flex;
                align-items:center;
                border-radius:999px;
                border:1px solid #24537a;
                background:#0f2d48;
                color:#9fc4df;
                padding:4px 9px;
                font-size:10px;
                font-weight:700;
                line-height:1.1;
                white-space:nowrap;
            }
            .contacts-pro .company-badge:hover{
                border-color:#d4af37;
                color:#f6d76b;
                background:#10324f;
            }

        `}</style>
    );
}


function ContactsLeadWebStyle() {
    return (
        <style>{`
            .contacts-pro{color:#f5fbff}
            .contacts-pro select option{background:#061a2f;color:white}
            .contacts-pro .crm-hero{background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);border:1px solid rgba(11,93,140,.8);box-shadow:0 20px 45px rgba(0,0,0,.28)}
            .contacts-pro .crm-card{border:1px solid rgba(11,93,140,.82);background:#04192b;box-shadow:0 12px 30px rgba(0,0,0,.24)}
            .contacts-pro .crm-card-head{background:#031425;border-bottom:1px solid #0b4d78}
            .contacts-pro .crm-actions-bar{background:#031425;border:1px solid #0b4d78;border-radius:22px}
            .contacts-pro .crm-btn{border:1px solid #24537a;background:#0b2740;color:#f5fbff;border-radius:999px;padding:10px 14px;font-size:12px;font-weight:700}
            .contacts-pro .crm-btn:hover{background:#10324f;border-color:#d4af37}
            .contacts-pro .crm-btn-primary{background:#d4af37;color:#081a2b;border-color:#d4af37}
            .contacts-pro .crm-btn-primary:hover{background:#e8c457}
            .contacts-pro .crm-input{width:100%;border:1px solid #0b5f91;border-radius:.85rem;padding:.65rem .75rem;font-size:12px;outline:none;background:#0b2740;color:#fff}
            .contacts-pro .crm-input::placeholder{color:#7ea8c7}
            .contacts-pro .crm-input:focus{border-color:#d4af37;box-shadow:0 0 0 2px rgba(212,175,55,.18)}
            .contacts-pro .crm-label{display:block;font-size:11px;color:#8fb9da;margin-bottom:6px;font-weight:700;text-transform:uppercase;letter-spacing:.14em}
            .contacts-pro table{border-collapse:separate;border-spacing:0;background:#061a2f}
            .contacts-pro table tbody tr{transition:background .18s ease, box-shadow .18s ease;background:#08233d!important}
            .contacts-pro table tbody tr:nth-child(even){background:#092a49!important}
            .contacts-pro table tbody tr:hover{background:rgba(56,189,248,.075)!important;box-shadow:inset 3px 0 0 #d4af37}
            .contacts-pro table tbody td{border-top:1px solid #24587c;background:transparent!important;color:#f5fbff}
            .contacts-pro table thead th{position:sticky;top:0;z-index:10;background:#061a2f!important;color:#8fb9da;border-bottom:1px solid #24587c;text-transform:uppercase;letter-spacing:.13em}
            .contacts-pro .crm-scroll{overflow:auto;max-height:70vh}
            .contacts-pro .crm-scroll-top{overflow-x:auto;overflow-y:hidden;height:14px;border:1px solid #24587c;border-radius:999px;background:#061a2f;margin:0 12px 8px 12px}
            .contacts-pro .crm-scroll-spacer{height:1px;min-width:1100px}
            .contacts-pro .crm-scroll::-webkit-scrollbar,.contacts-pro .crm-scroll-top::-webkit-scrollbar{height:10px;width:10px}
            .contacts-pro .crm-scroll::-webkit-scrollbar-track,.contacts-pro .crm-scroll-top::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .contacts-pro .crm-scroll::-webkit-scrollbar-thumb,.contacts-pro .crm-scroll-top::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .contacts-pro .crm-scroll::-webkit-scrollbar-thumb:hover,.contacts-pro .crm-scroll-top::-webkit-scrollbar-thumb:hover{background:#d4af37}
            .contacts-pro .grid-row-main{font-weight:700;color:#fff!important}
            .contacts-pro .grid-row-sub{color:#9fc4df!important;font-size:12px}
            .contacts-pro .crm-badge{display:inline-flex;align-items:center;border-radius:999px;border:1px solid #24537a;background:#0f2d48;color:#d9e8f5;padding:4px 9px;font-size:10px;font-weight:700}
            .contacts-pro .crm-modal-panel{background:#04192b;border:1px solid #0b5f91;color:#fff;box-shadow:0 20px 60px rgba(0,0,0,.35)}
            .contacts-pro .crm-modal-head{background:#031425;border-bottom:1px solid #0b4d78}
        `}</style>
    );
}


function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return {
        ...extra,
        Authorization: `Bearer ${token}`,
        "X-CANI-AUTH": token,
    };
}

const EMPTY_FORM = {
    affiliate_company_id: "",
    first_name: "",
    last_name: "",
    full_name: "",
    email: "",
    phone: "",
    mobile: "",
    position: "",
    birthday: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    family_info: "",
    profile_notes: "",
    personal_notes: "",
    status: "activo",
};

function getContactCompanies(contact, companiesCatalog = []) {
    if (Array.isArray(contact?.company_list) && contact.company_list.length > 0) {
        return contact.company_list
            .map((c) => {
                if (typeof c === "string") return c.trim();
                return c?.name ? String(c.name).trim() : "";
            })
            .filter(Boolean);
    }

    if (Array.isArray(contact?.company_names) && contact.company_names.length > 0) {
        return contact.company_names.map((x) => String(x).trim()).filter(Boolean);
    }

    if (contact?.company_name) {
        return String(contact.company_name)
            .split(",")
            .map((x) => x.trim())
            .filter(Boolean);
    }

    if (contact?.primary_affiliate_company_id) {
        const company = companiesCatalog.find(
            (item) => String(item.id) === String(contact.primary_affiliate_company_id)
        );
        if (company?.name) return [company.name];
    }

    return [];
}

function CompanyBadges({ contact, companiesCatalog = [] }) {
    const companyNames = getContactCompanies(contact, companiesCatalog);

    if (!companyNames.length) {
        return (
            <span className="inline-flex px-2 py-1 rounded-full border bg-[#0f2d48] text-[#d9e8f5] border-[#24537a] text-[10px]">
                Sin empresa
            </span>
        );
    }

    return (
        <div className="flex flex-wrap gap-1">
            {companyNames.map((name, idx) => (
                <span
                    key={`${name}-${idx}`}
                    className="company-badge"
                    title={name}
                >
                    {name}
                </span>
            ))}
        </div>
    );
}

function SearchableCompanyFilter({ companies, value, onChange }) {
    const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);

    const selectedCompany = useMemo(() => {
        if (value === "todas" || value === "sin_empresa") return null;
        return companies.find((c) => String(c.id) === String(value)) || null;
    }, [companies, value]);

    useEffect(() => {
        if (value === "todas") {
            setQuery("Todas");
            return;
        }
        if (value === "sin_empresa") {
            setQuery("Sin empresa");
            return;
        }
        if (selectedCompany) {
            const extra = selectedCompany.region ? ` · ${selectedCompany.region}` : "";
            setQuery(`${selectedCompany.name}${extra}`);
        } else {
            setQuery("");
        }
    }, [value, selectedCompany]);

    const filteredCompanies = useMemo(() => {
        const q = query.trim().toLowerCase();

        const base = companies.filter((company) =>
            [company.name, company.region, company.city]
                .filter(Boolean)
                .some((field) => String(field).toLowerCase().includes(q))
        );

        if (!q || q === "todas" || q === "sin empresa") {
            return companies.slice(0, 40);
        }

        return base.slice(0, 40);
    }, [companies, query]);

    return (
        <div className="relative">
            <input
                type="text"
                value={query}
                onFocus={() => setOpen(true)}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setOpen(true);
                }}
                placeholder="Buscar empresa por nombre o región..."
                className="crm-input"
            />

            <div className="mt-1 flex items-center gap-2">
                <button
                    type="button"
                    onClick={() => setOpen((prev) => !prev)}
                    className="crm-btn !px-3 !py-1.5 !text-[11px]"
                >
                    {open ? "Cerrar" : "Buscar"}
                </button>

                <button
                    type="button"
                    onClick={() => {
                        onChange("todas");
                        setQuery("Todas");
                        setOpen(false);
                    }}
                    className="crm-btn !px-3 !py-1.5 !text-[11px]"
                >
                    Limpiar
                </button>
            </div>

            {open && (
                <div className="absolute z-30 mt-2 w-full bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-xl overflow-hidden">
                    <div className="max-h-64 overflow-y-auto">
                        <button
                            type="button"
                            onClick={() => {
                                onChange("todas");
                                setQuery("Todas");
                                setOpen(false);
                            }}
                            className="w-full text-left px-3 py-2 text-xs hover:bg-[#10324f] border-b border-[#0b4d78]"
                        >
                            <div className="font-medium text-white">Todas</div>
                            <div className="text-[11px] text-[#9fc4df]">
                                Mostrar contactos de todas las empresas
                            </div>
                        </button>

                        <button
                            type="button"
                            onClick={() => {
                                onChange("sin_empresa");
                                setQuery("Sin empresa");
                                setOpen(false);
                            }}
                            className="w-full text-left px-3 py-2 text-xs hover:bg-[#10324f] border-b border-[#0b4d78]"
                        >
                            <div className="font-medium text-white">Sin empresa</div>
                            <div className="text-[11px] text-[#9fc4df]">
                                Mostrar solo contactos sin empresa
                            </div>
                        </button>

                        {filteredCompanies.length === 0 ? (
                            <div className="px-3 py-3 text-xs text-[#8fb9da]">
                                No se encontraron empresas.
                            </div>
                        ) : (
                            filteredCompanies.map((company) => (
                                <button
                                    key={company.id}
                                    type="button"
                                    onClick={() => {
                                        onChange(String(company.id));
                                        const extra = company.region ? ` · ${company.region}` : "";
                                        setQuery(`${company.name}${extra}`);
                                        setOpen(false);
                                    }}
                                    className={`w-full text-left px-3 py-2 text-xs hover:bg-[#10324f] border-b border-[#0b4d78] last:border-b-0 ${String(value) === String(company.id) ? "bg-[#08233d]" : ""
                                        }`}
                                >
                                    <div className="font-medium text-white">{company.name}</div>
                                    <div className="text-[11px] text-[#9fc4df]">
                                        {company.region || "Sin región"}
                                        {company.city ? ` · ${company.city}` : ""}
                                    </div>
                                </button>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

function CompanySearchSelect({ companies, value, onChange, disabled = false }) {
    const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);

    const selectedCompany = useMemo(() => {
        return companies.find((c) => String(c.id) === String(value)) || null;
    }, [companies, value]);

    useEffect(() => {
        if (selectedCompany) {
            const regionText = selectedCompany.region ? ` · ${selectedCompany.region}` : "";
            setQuery(`${selectedCompany.name}${regionText}`);
        } else {
            setQuery("");
        }
    }, [selectedCompany]);

    const filteredCompanies = useMemo(() => {
        const q = query.trim().toLowerCase();

        if (!q) return companies.slice(0, 30);

        return companies
            .filter((company) => {
                return [company.name, company.region, company.city]
                    .filter(Boolean)
                    .some((field) => String(field).toLowerCase().includes(q));
            })
            .slice(0, 30);
    }, [companies, query]);

    return (
        <div className="relative">
            <input
                type="text"
                value={query}
                disabled={disabled}
                onFocus={() => setOpen(true)}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setOpen(true);
                    if (!e.target.value.trim()) {
                        onChange("");
                    }
                }}
                placeholder="Buscar empresa por nombre o región..."
                className="crm-input"
            />

            <div className="mt-1 flex items-center gap-2">
                <button
                    type="button"
                    onClick={() => setOpen((prev) => !prev)}
                    className="crm-btn !px-3 !py-1.5 !text-[11px]"
                >
                    {open ? "Cerrar" : "Buscar"}
                </button>

                {value ? (
                    <button
                        type="button"
                        onClick={() => {
                            onChange("");
                            setQuery("");
                            setOpen(false);
                        }}
                        className="crm-btn !px-3 !py-1.5 !text-[11px]"
                    >
                        Quitar empresa
                    </button>
                ) : null}
            </div>

            {open && (
                <div className="absolute z-30 mt-2 w-full bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-xl overflow-hidden">
                    <div className="max-h-64 overflow-y-auto">
                        <button
                            type="button"
                            onClick={() => {
                                onChange("");
                                setQuery("");
                                setOpen(false);
                            }}
                            className="w-full text-left px-3 py-2 text-xs hover:bg-[#10324f] border-b border-[#0b4d78]"
                        >
                            <div className="font-medium text-white">Sin empresa</div>
                            <div className="text-[11px] text-[#9fc4df]">
                                Dejar el contacto sin empresa vinculada
                            </div>
                        </button>

                        {filteredCompanies.length === 0 ? (
                            <div className="px-3 py-3 text-xs text-[#8fb9da]">
                                No se encontraron empresas.
                            </div>
                        ) : (
                            filteredCompanies.map((company) => (
                                <button
                                    key={company.id}
                                    type="button"
                                    onClick={() => {
                                        onChange(String(company.id));
                                        const regionText = company.region ? ` · ${company.region}` : "";
                                        setQuery(`${company.name}${regionText}`);
                                        setOpen(false);
                                    }}
                                    className={`w-full text-left px-3 py-2 text-xs hover:bg-[#10324f] border-b border-[#0b4d78] last:border-b-0 ${String(value) === String(company.id) ? "bg-[#08233d]" : ""
                                        }`}
                                >
                                    <div className="font-medium text-white">{company.name}</div>
                                    <div className="text-[11px] text-[#9fc4df]">
                                        {company.region || "Sin región"}
                                        {company.city ? ` · ${company.city}` : ""}
                                    </div>
                                </button>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

function ContactModal({
    open,
    onClose,
    formMode,
    form,
    setForm,
    handleChange,
    handleSubmit,
    saving,
    companies,
    onDelete,
    deleting,
}) {
    if (!open) return null;

    return (
        <>
            <div className="fixed inset-0 bg-[#010b14]/75 backdrop-blur-sm z-[90]" onClick={onClose} />
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                <div className="w-full max-w-6xl max-h-[92vh] overflow-auto crm-modal-panel rounded-[24px]">
                    <div className="sticky top-0 crm-modal-head px-5 py-4 flex items-center justify-between z-10">
                        <div>
                            <h3 className="text-sm font-semibold text-white">
                                {formMode === "create" ? "Nuevo contacto" : "Editar contacto"}
                            </h3>
                            <p className="text-[11px] text-[#9fc4df]">
                                Empresa opcional. Puedes buscar por nombre o región.
                            </p>
                        </div>

                        <button
                            type="button"
                            onClick={onClose}
                            className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-xs text-[#d9e8f5] hover:bg-[#10324f]"
                        >
                            Cerrar
                        </button>
                    </div>

                    <form onSubmit={handleSubmit} className="p-4 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                            <div>
                                <label className="crm-label">
                                    Empresa
                                </label>

                                <CompanySearchSelect
                                    companies={companies}
                                    value={form.affiliate_company_id}
                                    onChange={(nextValue) =>
                                        setForm((prev) => ({
                                            ...prev,
                                            affiliate_company_id: nextValue,
                                        }))
                                    }
                                />
                            </div>

                            <div>
                                <label className="crm-label">Nombre *</label>
                                <input
                                    type="text"
                                    name="first_name"
                                    value={form.first_name}
                                    onChange={handleChange}
                                    className="crm-input"
                                    required
                                />
                            </div>

                            <div>
                                <label className="crm-label">Apellidos</label>
                                <input
                                    type="text"
                                    name="last_name"
                                    value={form.last_name}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div className="md:col-span-2 xl:col-span-3">
                                <label className="crm-label">Nombre completo *</label>
                                <input
                                    type="text"
                                    name="full_name"
                                    value={form.full_name}
                                    onChange={handleChange}
                                    className="crm-input"
                                    required
                                />
                            </div>

                            <div>
                                <label className="crm-label">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Teléfono</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Celular</label>
                                <input
                                    type="text"
                                    name="mobile"
                                    value={form.mobile}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Puesto / Rol</label>
                                <input
                                    type="text"
                                    name="position"
                                    value={form.position}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Cumpleaños</label>
                                <input
                                    type="date"
                                    name="birthday"
                                    value={form.birthday || ""}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Estatus</label>
                                <select
                                    name="status"
                                    value={form.status}
                                    onChange={handleChange}
                                    className="crm-input"
                                >
                                    <option value="activo">Activo</option>
                                    <option value="inactivo">Inactivo</option>
                                </select>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            <div>
                                <label className="crm-label">Facebook</label>
                                <input
                                    type="text"
                                    name="facebook"
                                    value={form.facebook}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Instagram</label>
                                <input
                                    type="text"
                                    name="instagram"
                                    value={form.instagram}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">LinkedIn</label>
                                <input
                                    type="text"
                                    name="linkedin"
                                    value={form.linkedin}
                                    onChange={handleChange}
                                    className="crm-input"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 xl:grid-cols-3 gap-3">
                            <div>
                                <label className="crm-label">Información familiar</label>
                                <textarea
                                    name="family_info"
                                    value={form.family_info}
                                    onChange={handleChange}
                                    rows={4}
                                    className="crm-input resize-none"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Notas de perfil</label>
                                <textarea
                                    name="profile_notes"
                                    value={form.profile_notes}
                                    onChange={handleChange}
                                    rows={4}
                                    className="crm-input resize-none"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Notas personales</label>
                                <textarea
                                    name="personal_notes"
                                    value={form.personal_notes}
                                    onChange={handleChange}
                                    rows={4}
                                    className="crm-input resize-none"
                                />
                            </div>
                        </div>

                        <div className="flex justify-between items-center gap-2 pt-2">
                            <div>
                                {formMode === "edit" ? (
                                    <button
                                        type="button"
                                        onClick={onDelete}
                                        disabled={deleting}
                                        className="px-3 py-1.5 rounded-lg border border-[#ef4444]/40 text-[#fca5a5] text-xs hover:bg-[#2b1117] disabled:opacity-60"
                                    >
                                        {deleting ? "Eliminando..." : "Eliminar contacto"}
                                    </button>
                                ) : (
                                    <span className="text-[11px] text-[#8fb9da]">—</span>
                                )}
                            </div>

                            <div className="flex justify-end gap-2">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] text-xs hover:bg-[#10324f]"
                                >
                                    Cancelar
                                </button>

                                <button
                                    type="submit"
                                    disabled={saving}
                                    className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight disabled:opacity-60"
                                >
                                    {saving
                                        ? "Guardando..."
                                        : formMode === "create"
                                            ? "Crear contacto"
                                            : "Guardar cambios"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

const ContactsPage = () => {
    const navigate = useNavigate();

    const [contacts, setContacts] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState("");

    const [showForm, setShowForm] = useState(false);
    const [formMode, setFormMode] = useState("create");
    const [editingId, setEditingId] = useState(null);

    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("todos");
    const [companyFilter, setCompanyFilter] = useState("todas");

    const [form, setForm] = useState(EMPTY_FORM);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            setError("");

            const [companiesRes, contactsRes] = await Promise.all([
                fetch(`${API_BASE}/affiliate_companies_list.php`, {
                    headers: authHeaders(),
                }),
                fetch(`${API_BASE}/contacts_list.php`, {
                    headers: authHeaders(),
                }),
            ]);

            const companiesData = await companiesRes.json().catch(() => []);
            const contactsData = await contactsRes.json().catch(() => []);

            const companyRows = Array.isArray(companiesData)
                ? companiesData
                : Array.isArray(companiesData?.rows)
                    ? companiesData.rows
                    : [];

            const contactRows = Array.isArray(contactsData)
                ? contactsData
                : Array.isArray(contactsData?.rows)
                    ? contactsData.rows
                    : [];

            setCompanies(companyRows);
            setContacts(contactRows);
        } catch (err) {
            console.error(err);
            setError("No se pudieron cargar los contactos.");
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setForm(EMPTY_FORM);
        setEditingId(null);
        setFormMode("create");
    };

    const closeModal = () => {
        setShowForm(false);
        resetForm();
    };

    const handleNew = () => {
        resetForm();
        setFormMode("create");
        setShowForm(true);
    };

    const handleEdit = (c) => {
        setForm({
            affiliate_company_id: c.primary_affiliate_company_id
                ? String(c.primary_affiliate_company_id)
                : "",
            first_name: c.first_name || "",
            last_name: c.last_name || "",
            full_name:
                c.full_name ||
                [c.first_name, c.last_name].filter(Boolean).join(" ").trim(),
            email: c.email || "",
            phone: c.phone || "",
            mobile: c.mobile || "",
            position: c.position || "",
            birthday: c.birthday || "",
            facebook: c.facebook || "",
            instagram: c.instagram || "",
            linkedin: c.linkedin || "",
            family_info: c.family_info || "",
            profile_notes: c.profile_notes || "",
            personal_notes: c.personal_notes || "",
            status: c.status || "activo",
        });
        setEditingId(c.id);
        setFormMode("edit");
        setShowForm(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => {
            const next = { ...prev, [name]: value };

            if (name === "first_name" || name === "last_name") {
                const autoFullName = `${name === "first_name" ? value : prev.first_name} ${name === "last_name" ? value : prev.last_name}`.trim();
                next.full_name = autoFullName;
            }

            return next;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const firstName = form.first_name.trim();
        const lastName = form.last_name.trim();
        const fullName = form.full_name.trim() || `${firstName} ${lastName}`.trim();

        if (!firstName) {
            setError("El nombre es obligatorio.");
            return;
        }

        if (!fullName) {
            setError("El nombre completo es obligatorio.");
            return;
        }

        try {
            setSaving(true);

            const payload = {
                ...form,
                first_name: firstName,
                last_name: lastName,
                full_name: fullName,
                affiliate_company_id: form.affiliate_company_id
                    ? Number(form.affiliate_company_id)
                    : null,
            };

            let url = `${API_BASE}/contact_create.php`;

            if (formMode === "edit") {
                url = `${API_BASE}/contact_update.php`;
                payload.id = editingId;
            }

            const res = await fetch(url, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok || data.success === false) {
                throw new Error(data.error || "No se pudo guardar el contacto.");
            }

            await fetchData();
            closeModal();
            alert(
                formMode === "create"
                    ? "Contacto creado correctamente."
                    : "Contacto actualizado correctamente."
            );
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al guardar el contacto.");
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async () => {
        if (!editingId) return;
        if (!window.confirm("¿Eliminar este contacto?")) return;

        try {
            setDeleting(true);
            setError("");

            const res = await fetch(`${API_BASE}/contact_delete.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ id: editingId }),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok || data.success === false) {
                throw new Error(data.error || "No se pudo eliminar el contacto.");
            }

            await fetchData();
            closeModal();
            alert("Contacto eliminado correctamente.");
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al eliminar el contacto.");
        } finally {
            setDeleting(false);
        }
    };

    const filteredContacts = useMemo(() => {
        const q = search.trim().toLowerCase();

        return contacts.filter((c) => {
            const companyNames = getContactCompanies(c, companies);

            const matchesSearch =
                !q ||
                [
                    c.full_name,
                    c.first_name,
                    c.last_name,
                    c.email,
                    c.phone,
                    c.mobile,
                    c.position,
                    ...companyNames,
                    c.family_info,
                    c.profile_notes,
                    c.personal_notes,
                ]
                    .filter(Boolean)
                    .some((value) => String(value).toLowerCase().includes(q));

            const matchesStatus =
                statusFilter === "todos"
                    ? true
                    : (c.status || "").toLowerCase() === statusFilter.toLowerCase();

            const matchesCompany =
                companyFilter === "todas"
                    ? true
                    : companyFilter === "sin_empresa"
                        ? getContactCompanies(c, companies).length === 0
                        : companyNames.some((name) => {
                            const company = companies.find((item) => item.name === name);
                            return company && String(company.id) === String(companyFilter);
                        }) || String(c.primary_affiliate_company_id) === String(companyFilter);

            return matchesSearch && matchesStatus && matchesCompany;
        });
    }, [contacts, companies, search, statusFilter, companyFilter]);

    const stats = useMemo(() => {
        const total = contacts.length;
        const activos = contacts.filter(
            (c) => (c.status || "").toLowerCase() === "activo"
        ).length;
        const conEmpresa = contacts.filter(
            (c) => getContactCompanies(c, companies).length > 0
        ).length;
        const sinEmpresa = contacts.filter(
            (c) => getContactCompanies(c, companies).length === 0
        ).length;

        return { total, activos, conEmpresa, sinEmpresa };
    }, [contacts, companies]);

    return (
        <MainLayout>
            <GridRowsProStyle />
            <ContactsLeadWebStyle />
            <div className="contacts-pro min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8 grid-rows-pro"><div className="mx-auto max-w-[1500px] space-y-6">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                    <div>
                        <p className="mb-3 inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]"><span className="h-px w-10 bg-[#D4AF37]" />CRM Comercial</p><h2 className="text-3xl md:text-4xl font-black tracking-tight text-white">Contactos</h2>
                        <p className="text-sm md:text-base text-[#d7e8f6] max-w-3xl leading-relaxed">Personas clave, decisores, aliados y relaciones comerciales vinculadas al CRM.</p>
                    </div>

                    <button
                        type="button"
                        onClick={handleNew}
                        className="px-3 py-2 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight"
                    >
                        + Nuevo contacto
                    </button>
                </div>

                {error && (
                    <div className="text-xs text-[#fca5a5] bg-[#2b1117] border border-[#ef4444]/40 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                <div className="grid grid-cols-2 xl:grid-cols-4 gap-3">
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                        <div className="text-[11px] text-[#9fc4df]">Total</div>
                        <div className="text-xl font-semibold text-white">{stats.total}</div>
                    </div>
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                        <div className="text-[11px] text-[#9fc4df]">Activos</div>
                        <div className="text-xl font-semibold text-white">{stats.activos}</div>
                    </div>
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                        <div className="text-[11px] text-[#9fc4df]">Con empresa</div>
                        <div className="text-xl font-semibold text-white">{stats.conEmpresa}</div>
                    </div>
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                        <div className="text-[11px] text-[#9fc4df]">Sin empresa</div>
                        <div className="text-xl font-semibold text-white">{stats.sinEmpresa}</div>
                    </div>
                </div>

                <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm p-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div>
                            <label className="crm-label">Buscar</label>
                            <input
                                type="text"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Nombre, email, empresa, puesto..."
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">Estatus</label>
                            <select
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                                className="crm-input"
                            >
                                <option value="todos">Todos</option>
                                <option value="activo">Activo</option>
                                <option value="inactivo">Inactivo</option>
                            </select>
                        </div>

                        <div>
                            <label className="crm-label">Empresa</label>
                            <SearchableCompanyFilter
                                companies={companies}
                                value={companyFilter}
                                onChange={setCompanyFilter}
                            />
                        </div>
                    </div>
                </div>

                <div className="crm-card rounded-[24px] overflow-hidden">
                    <div className="crm-card-head px-5 py-4 flex items-center justify-between">
                        <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37]">Lista de contactos</h3>
                        <span className="text-[11px] text-[#9fc4df]">
                            Mostrando: {filteredContacts.length}
                        </span>
                    </div>

                    <div className="max-h-[65vh] overflow-auto">
                        <table className="min-w-full text-xs">
                            <thead className="bg-[#08233d]">
                                <tr className="text-left text-[11px] font-semibold text-[#d7e8f6]">
                                    <th className="px-3 py-2">Nombre</th>
                                    <th className="px-3 py-2 hidden md:table-cell">Empresa</th>
                                    <th className="px-3 py-2 hidden lg:table-cell">Contacto</th>
                                    <th className="px-3 py-2 hidden xl:table-cell">Puesto</th>
                                    <th className="px-3 py-2 hidden xl:table-cell">Cumpleaños</th>
                                    <th className="px-3 py-2">Estatus</th>
                                    <th className="px-3 py-2 text-right">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr>
                                        <td colSpan={7} className="px-3 py-4 text-center text-[#9fc4df]">
                                            Cargando contactos...
                                        </td>
                                    </tr>
                                )}

                                {!loading && filteredContacts.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="px-3 py-4 text-center text-[#8fb9da]">
                                            No hay contactos para mostrar.
                                        </td>
                                    </tr>
                                )}

                                {!loading &&
                                    filteredContacts.map((c) => (
                                        <tr
                                            key={c.id}
                                            className="border-t border-[#0b4d78] hover:bg-[#10324f]/60"
                                        >
                                            <td className="px-3 py-2 text-[11px] text-white align-top">
                                                <div className="font-medium">
                                                    {c.full_name ||
                                                        [c.first_name, c.last_name].filter(Boolean).join(" ") ||
                                                        "-"}
                                                </div>
                                                <div className="text-[#9fc4df] md:hidden mt-1">
                                                    <CompanyBadges contact={c} companiesCatalog={companies} />
                                                </div>
                                            </td>

                                            <td className="px-3 py-2 hidden md:table-cell text-[11px] text-[#d7e8f6] align-top">
                                                <CompanyBadges contact={c} companiesCatalog={companies} />
                                            </td>

                                            <td className="px-3 py-2 hidden lg:table-cell text-[11px] text-[#d7e8f6] align-top">
                                                <div>{c.email || "-"}</div>
                                                <div>{c.mobile || c.phone || "-"}</div>
                                            </td>

                                            <td className="px-3 py-2 hidden xl:table-cell text-[11px] text-[#d7e8f6] align-top">
                                                {c.position || "-"}
                                            </td>

                                            <td className="px-3 py-2 hidden xl:table-cell text-[11px] text-[#d7e8f6] align-top">
                                                {c.birthday || "No capturado"}
                                            </td>

                                            <td className="px-3 py-2 text-[11px] align-top">
                                                <span
                                                    className={`inline-flex px-2 py-1 rounded-full border ${(c.status || "").toLowerCase() === "activo"
                                                        ? "bg-[#0b3a36] text-[#7cebd0] border-[#10b981]/40"
                                                        : "bg-[#0f2d48] text-[#d9e8f5] border-[#24537a]"
                                                        }`}
                                                >
                                                    {c.status || "activo"}
                                                </span>
                                            </td>

                                            <td className="px-3 py-2 text-right text-[11px] text-[#d7e8f6] align-top">
                                                <div className="flex justify-end gap-2">
                                                    <button
                                                        type="button"
                                                        onClick={() => navigate(`/contacts/${c.id}`)}
                                                        className="px-2 py-1 rounded-lg border border-[#0b4d78] hover:bg-[#10324f]"
                                                    >
                                                        Ver detalle
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleEdit(c)}
                                                        className="px-2 py-1 rounded-lg border border-[#0b4d78] hover:bg-[#10324f]"
                                                    >
                                                        Editar
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <ContactModal
                    open={showForm}
                    onClose={closeModal}
                    formMode={formMode}
                    form={form}
                    setForm={setForm}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    saving={saving}
                    companies={companies}
                    onDelete={handleDelete}
                    deleting={deleting}
                />
            </div>
            </div>
        </MainLayout>
    );
};

export default ContactsPage;
